import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { COLLECTIONS } from "../collections";

/**
 * Lista todas as matrículas ativas de um membro.
 */
export const listMemberEnrollments = async (idTenant, idMember) => {
    if (!idTenant || !idMember) return [];

    try {
        const enrollmentsRef = collection(db, "tenants", idTenant, COLLECTIONS.ENROLLMENTS);
        const q = query(
            enrollmentsRef,
            where("idMember", "==", idMember),
            where("status", "==", "active")
        );

        const snapshot = await getDocs(q);
        return snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
    } catch (error) {
        console.error("[EnrollmentService] Erro ao listar matrículas:", error);
        return [];
    }
};

/**
 * Lista TODAS as matrículas de um membro (ativas + canceladas).
 */
export const listAllMemberEnrollments = async (idTenant, idMember) => {
    if (!idTenant || !idMember) return [];

    try {
        const enrollmentsRef = collection(db, "tenants", idTenant, COLLECTIONS.ENROLLMENTS);
        const q = query(
            enrollmentsRef,
            where("idMember", "==", idMember)
        );

        const snapshot = await getDocs(q);
        return snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
    } catch (error) {
        console.error("[EnrollmentService] Erro ao listar todas as matrículas:", error);
        return [];
    }
};

/**
 * Verifica se existem alunos matriculados em uma turma.
 * Consulta membros que tenham essa turma no array enrolledClassIds.
 */
export const getEnrolledMembersByClass = async (idTenant, idClass) => {
    if (!idTenant || !idClass) return [];

    try {
        const q = query(
            collection(db, "tenants", idTenant, COLLECTIONS.MEMBERS),
            where("enrolledClassIds", "array-contains", idClass)
        );

        const snapshot = await getDocs(q);
        return snapshot.docs.map(docSnap => {
            const data = docSnap.data();
            return {
                id: docSnap.id,
                fullName: data.fullName || data.name || "Aluno sem nome",
                idMember: data.idMember || ""
            };
        });
    } catch (error) {
        console.error("[EnrollmentService] Erro ao verificar matrículas:", error);
        return [];
    }
};
